// 新着の「and more」ボタン
document.addEventListener("DOMContentLoaded", function(){

	const button = document.getElementById("index_view_btn");

	if (!button) return;

	button.addEventListener("click", function(){

		const items = document.querySelectorAll(
			'.collection .slider-mobile-gutter ul li:nth-child(n+11)'
		);

		items.forEach(function(item){
			item.style.display = "block";
		});

		button.style.display = "none";

	});

});



// ランキングのアロー
document.addEventListener("DOMContentLoaded", function(){

  const wrapper = document.querySelector(".reterior-app-wrapper");
  const inner = document.querySelector(".reterior-app-wrapper .tw-mx-auto");

  if (!wrapper || !inner) return;

  // ===== ボタン生成 =====
  const prev = document.createElement("p");
  prev.className = "prev";
  prev.textContent = "<";

  const next = document.createElement("p");
  next.className = "next";
  next.textContent = ">";

  wrapper.appendChild(prev);
  wrapper.appendChild(next);

  // ===== スライド設定 =====
  let current = 0;
  const step = 250;   // 1回の移動量
  const num = 20 - 5; // MAX - デフォルト表示数
  const max = -(step * num); // 左端
  const min = 0;             // 右端

  // ===== スマホ判定 =====
  const isMobile = () => window.innerWidth <= 749;

  // ===== PC: ボタンクリック =====
  next.addEventListener("click", function(){
    current = Math.max(current - step, max);
    inner.style.transform = `translateX(${current}px)`;
  });

  prev.addEventListener("click", function(){
    current = Math.min(current + step, min);
    inner.style.transform = `translateX(${current}px)`;
  });

  // ===== スマホ: タッチスワイプ =====
  let touchStartX = 0;
  let touchStartCurrent = 0;
  let isSwiping = false;

  inner.addEventListener("touchstart", function(e){
    if (!isMobile()) return;
    touchStartX = e.touches[0].clientX;
    touchStartCurrent = current;
    isSwiping = false;
  }, { passive: true });

  inner.addEventListener("touchmove", function(e){
    if (!isMobile()) return;
    const dx = e.touches[0].clientX - touchStartX;
    if (Math.abs(dx) > 8) isSwiping = true;
    if (!isSwiping) return;

    // ドラッグ中はリアルタイムで追従
    const dragged = touchStartCurrent + dx;
    inner.style.transition = "none";
    inner.style.transform = `translateX(${dragged}px)`;
  }, { passive: true });

  inner.addEventListener("touchend", function(e){
    if (!isMobile() || !isSwiping) return;
    const dx = e.changedTouches[0].clientX - touchStartX;

    // 常に1ステップだけ移動（速くスワイプしても飛ばない）
    if (dx < -30) {
      // 左スワイプ → 次へ
      current = Math.max(current - step, max);
    } else if (dx > 30) {
      // 右スワイプ → 前へ
      current = Math.min(current + step, min);
    } else {
      // 30px未満の微小な動きは元の位置に戻す
      current = touchStartCurrent;
    }

    inner.style.transition = "transform 0.3s ease";
    inner.style.transform = `translateX(${current}px)`;
    isSwiping = false;
  }, { passive: true });

  // ===== スマホではボタンを非表示にするCSS =====
  const style = document.createElement("style");
  style.textContent = `
    @media screen and (max-width: 749px) {
      .reterior-app-wrapper .prev,
      .reterior-app-wrapper .next {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);

});